import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Spacing8 } from 'autogen/design-tokens/tokens';
import type { ProductReviewListModel } from 'autogen/swagger/all';
import { ReviewsAnchorLink } from 'autogen/translation-keys/trans-website-productreview';
import InlineButton from 'components/generic/InlineButton';
import RatingStars from 'components/generic/ratingStars';
import { GA4Tracking } from 'modules/tracking/GA4';

const Wrapper = styled(InlineButton)`
    display: inline-flex;
    flex-direction: row;
    align-items: center;
`;

const StyledRatingStars = styled(RatingStars)`
    margin-right: ${Spacing8};
`;

interface IReviewAnchor {
    reviews: ProductReviewListModel;
}

export default function ReviewAnchor({ reviews, ...restProps }: IReviewAnchor): JSX.Element {
    const {
        reviewStatistics: { averageRating, reviewCount, showReviewAverage }
    } = reviews;
    const { t } = useTranslation();
    const averageRatingText = showReviewAverage ? reviewCount : t(ReviewsAnchorLink);

    return (
        <Wrapper
            href="#anchorReviews"
            forwardedAs="a"
            onClick={(e) => {
                e.preventDefault();
                document.getElementById('anchorReviews')?.scrollIntoView({
                    behavior: 'smooth'
                });
                GA4Tracking({
                    eventName: 'link_click',
                    context: 'product_page',
                    category: 'ecommerce',
                    eventParams: [
                        { param_name: 'link_type', param_value: 'internal' },
                        { param_name: 'link_sub_type', param_value: 'anchor' },
                        { param_name: 'link_text', param_value: `review: ${averageRatingText}` }
                    ]
                });
            }}
            size={{ xs: 'S', lg: 'M' }}
            {...restProps}
        >
            <StyledRatingStars size="M" rating={averageRating} />
            {typeof averageRatingText === 'number' ? `(${averageRatingText})` : averageRatingText}
        </Wrapper>
    );
}
